var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.608,
    height: 57.608,
    viewBox: "0 0 57.608 57.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16713",
    "data-name": "Group 16713",
    transform: "translate(-46 -45.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spy_1_",
    "data-name": "spy (1)",
    transform: "translate(46 45.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16695",
    "data-name": "Group 16695",
    transform: "translate(12.002 19.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16694",
    "data-name": "Group 16694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11860",
    "data-name": "Path 11860",
    d: "M136.45,170.693a1.2,1.2,0,1,0,.238,2.388c.01,0,.024,0,.036,0,.338.13,1.147,1.39,1.147,3.591,0,2.324-.881,3.562-1.275,3.548a1.2,1.2,0,0,0-1.8.73c-1.68,6.774-6.234,11.325-11.332,11.325s-9.652-4.551-11.332-11.325a1.216,1.216,0,0,0-.749-.794,1.287,1.287,0,0,0-1.121.118c-.3,0-1.2-1.277-1.2-3.6,0-2.2.809-3.461,1.147-3.591a.22.22,0,0,0,.036,0,1.275,1.275,0,0,0,1.4-1.059,1.123,1.123,0,0,0-.991-1.3,1.64,1.64,0,0,0-.389-.058c-2.052,0-3.6,2.58-3.6,6,0,3.339,1.474,5.876,3.452,6,2.182,7.23,7.436,12.007,13.351,12.007s11.169-4.777,13.351-12.007c1.978-.12,3.452-2.657,3.452-6C140.271,173.247,138.828,170.7,136.45,170.693Z",
    transform: "translate(-106.666 -170.667)",
    fill: "#ec6321"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16697",
    "data-name": "Group 16697",
    transform: "translate(19.144 20.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16696",
    "data-name": "Group 16696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11861",
    "data-name": "Path 11861",
    d: "M175,181.333c-5.751,0-4.8,1.613-4.8,3.6s.948,3.6,3.6,3.6,6-1.613,6-3.6S180.556,181.333,175,181.333Z",
    transform: "translate(-170.145 -181.333)",
    fill: "#ec6321"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16699",
    "data-name": "Group 16699",
    transform: "translate(17.944 19.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16698",
    "data-name": "Group 16698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11862",
    "data-name": "Path 11862",
    d: "M170.787,171.973c-.879-.915-2.446-1.306-5.247-1.306-2.912,0-4.455.379-5.326,1.306a3.468,3.468,0,0,0-.7,2.825c.014.216.029.439.029.67a4.412,4.412,0,0,0,4.8,4.8c3.008,0,7.2-1.827,7.2-4.8,0-.2.007-.4.017-.588A3.648,3.648,0,0,0,170.787,171.973Zm-1.627,2.806c-.01.223-.019.454-.019.689,0,.991-2.482,2.4-4.8,2.4-1.659,0-2.4-.742-2.4-2.4,0-.281-.017-.557-.034-.821-.026-.446-.058-.907.058-1.03s.737-.55,3.577-.55c2.681,0,3.351.4,3.514.567S169.181,174.27,169.159,174.779Z",
    transform: "translate(-159.48 -170.667)",
    fill: "#ec6321"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16701",
    "data-name": "Group 16701",
    transform: "translate(28.804 20.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16700",
    "data-name": "Group 16700"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11863",
    "data-name": "Path 11863",
    d: "M260.832,181.333c-5.55,0-4.8,1.613-4.8,3.6s3.315,3.6,5.967,3.6a3.267,3.267,0,0,0,3.634-3.6C265.633,182.946,266.583,181.333,260.832,181.333Z",
    transform: "translate(-255.997 -181.333)",
    fill: "#ec6321"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16703",
    "data-name": "Group 16703",
    transform: "translate(27.604 19.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16702",
    "data-name": "Group 16702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11864",
    "data-name": "Path 11864",
    d: "M256.692,171.973c-.871-.927-2.415-1.306-5.326-1.306-2.8,0-4.369.391-5.247,1.306a3.631,3.631,0,0,0-.771,2.907c.01.192.017.389.017.588,0,2.974,4.174,4.8,7.167,4.8a4.469,4.469,0,0,0,4.832-4.8c0-.228.017-.454.029-.67A3.458,3.458,0,0,0,256.692,171.973ZM255,174.647c-.017.264-.034.54-.034.821,0,1.659-.751,2.4-2.434,2.4-2.3,0-4.767-1.409-4.767-2.4,0-.235-.01-.466-.019-.689-.022-.509-.043-.991.106-1.145s.833-.567,3.514-.567c2.84,0,3.457.42,3.579.55A2.148,2.148,0,0,1,255,174.647Z",
    transform: "translate(-245.331 -170.667)",
    fill: "#ec6321"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16705",
    "data-name": "Group 16705",
    transform: "translate(4.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16704",
    "data-name": "Group 16704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11865",
    "data-name": "Path 11865",
    d: "M80.138,10.83C78.268,5.156,74.867,0,71.47,0a7.347,7.347,0,0,0-4.8,1.884A7.347,7.347,0,0,0,61.869,0c-3.4,0-6.8,5.156-8.668,10.83-9.253,1.6-10.535,3.236-10.535,4.772,0,4.738,15.089,6,24,6s24-1.263,24-6C90.673,14.066,89.391,12.427,80.138,10.83Zm-1.745.739c-.242.29-2.624,2.832-11.723,2.832S55.189,11.86,54.946,11.57A1.2,1.2,0,0,1,56.763,10c.1.091,2.184,2,9.906,2,7.873,0,9.889-1.983,9.909-2a1.228,1.228,0,0,1,1.68-.072A1.178,1.178,0,0,1,78.393,11.57Z",
    transform: "translate(-42.666)",
    fill: "#ec6321"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16707",
    "data-name": "Group 16707",
    transform: "translate(0 44.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16706",
    "data-name": "Group 16706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11866",
    "data-name": "Path 11866",
    d: "M20.818,402.844l-4.813-3.207a3.579,3.579,0,0,1-1.507-2.17,1.2,1.2,0,0,0-.787-.862l-.449-.151a3.6,3.6,0,0,1-1.407-.869l-3.749-3.749a1.2,1.2,0,0,0-1.515-.151A14.441,14.441,0,0,0,0,403.843a1.2,1.2,0,0,0,1.2,1.2H20.151a1.2,1.2,0,0,0,.667-2.2Z",
    transform: "translate(0 -391.483)",
    fill: "#ec6321"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16709",
    "data-name": "Group 16709",
    transform: "translate(7.2 36.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16708",
    "data-name": "Group 16708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11867",
    "data-name": "Path 11867",
    d: "M107.165,323.332a1.193,1.193,0,0,0-.79-.862l-7.2-2.4a1.2,1.2,0,0,0-1.368.458L85.6,338.294,73.382,320.529a1.2,1.2,0,0,0-1.368-.458l-7.2,2.4a1.2,1.2,0,0,0-.471,1.985l6,6a1.22,1.22,0,0,0,.468.29l2.782.927v1.536a1.2,1.2,0,0,0,.535,1L84.916,341.4a1.177,1.177,0,0,0,.679.211,1.2,1.2,0,0,0,.466-.094,1.013,1.013,0,0,0,.211-.118l10.79-7.191a1.2,1.2,0,0,0,.535-1v-1.536l2.78-.927a1.159,1.159,0,0,0,.468-.29l6-6A1.2,1.2,0,0,0,107.165,323.332Z",
    transform: "translate(-63.991 -320.009)",
    fill: "#ec6321"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16711",
    "data-name": "Group 16711",
    transform: "translate(36.256 44.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16710",
    "data-name": "Group 16710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11868",
    "data-name": "Path 11868",
    d: "M336.988,391.706a1.2,1.2,0,0,0-1.515.151l-3.752,3.752a3.6,3.6,0,0,1-1.407.869l-.446.149a1.2,1.2,0,0,0-.787.862,3.586,3.586,0,0,1-1.507,2.17l-4.81,3.207a1.2,1.2,0,0,0,.667,2.2h18.951a1.2,1.2,0,0,0,1.2-1.2A14.431,14.431,0,0,0,336.988,391.706Z",
    transform: "translate(-322.23 -391.504)",
    fill: "#ec6321"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16712",
    "data-name": "Group 16712",
    transform: "translate(50.801 45.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16704-2",
    "data-name": "Group 16704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11865-2",
    "data-name": "Path 11865",
    d: "M78.393,11.57c-.242.29-2.624,2.832-11.723,2.832S55.189,11.86,54.946,11.57A1.2,1.2,0,0,1,56.763,10c.1.091,2.184,2,9.906,2,7.873,0,9.889-1.983,9.909-2a1.228,1.228,0,0,1,1.68-.072A1.178,1.178,0,0,1,78.393,11.57Z",
    transform: "translate(-42.666)",
    fill: "#fdb697"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.4949e475500abe477f5a5f73001223fa.svg";
export { ForwardRef as ReactComponent };